/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TaxType } from './';
import {
    TaxTypeFromJSON,
    TaxTypeFromJSONTyped,
    TaxTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyTax
 */
export interface CompanyTax {
    /**
     * 
     * @type {string}
     * @memberof CompanyTax
     */
    id: string;
    /**
     * 
     * @type {TaxType}
     * @memberof CompanyTax
     */
    taxType: TaxType;
    /**
     * 
     * @type {number}
     * @memberof CompanyTax
     */
    percent: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyTax
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTax
     */
    descriptionKey: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTax
     */
    placeholder?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyTax
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyTax
     */
    minPercent: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyTax
     */
    maxPercent: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompanyTax
     */
    eligiblePercents: Array<number>;
}

/**
 * Check if a given object implements the CompanyTax interface.
 */
export function instanceOfCompanyTax(value: object): value is CompanyTax {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('taxType' in value) || value['taxType'] === undefined) return false;
    if (!('percent' in value) || value['percent'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('descriptionKey' in value) || value['descriptionKey'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('minPercent' in value) || value['minPercent'] === undefined) return false;
    if (!('maxPercent' in value) || value['maxPercent'] === undefined) return false;
    if (!('eligiblePercents' in value) || value['eligiblePercents'] === undefined) return false;
    return true;
}

export function CompanyTaxFromJSON(json: any): CompanyTax {
    return CompanyTaxFromJSONTyped(json, false);
}

export function CompanyTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTax {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'taxType': TaxTypeFromJSON(json['taxType']),
        'percent': json['percent'],
        'description': json['description'],
        'descriptionKey': json['descriptionKey'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
        'required': json['required'],
        'minPercent': json['minPercent'],
        'maxPercent': json['maxPercent'],
        'eligiblePercents': json['eligiblePercents'],
    };
}

export function CompanyTaxToJSON(value?: CompanyTax | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'taxType': TaxTypeToJSON(value['taxType']),
        'percent': value['percent'],
        'description': value['description'],
        'descriptionKey': value['descriptionKey'],
        'placeholder': value['placeholder'],
        'required': value['required'],
        'minPercent': value['minPercent'],
        'maxPercent': value['maxPercent'],
        'eligiblePercents': value['eligiblePercents'],
    };
}

